import { getCurrentFeatureCode } from '@/app/core/auth';
import { getEntitlementForContext, isAuthzAnyValue } from '@ascend/authz';
import {
  AppUserProfile,
  getShortNameForProductToLower,
  ProductNameEnum,
} from '@ssar-app/domain';

export const hasEntitlementsWithProductAsContext = (
  product: string,
  userProfile: AppUserProfile,
): boolean => {
  const entitlements = userProfile.entitlements || [];
  if (isAuthzAnyValue(entitlements)) {
    return true;
  }
  const entitlementsForContext = getEntitlementForContext(
    product,
    entitlements,
  );
  return entitlementsForContext !== null;
};

export const getProductRouterPath = () => {
  const featureCode = getCurrentFeatureCode();
  return getShortNameForProductToLower(featureCode || '');
};

export const isAscendQuestProduct = (productName?: string) => {
  const featureCode = getCurrentFeatureCode();
  return ProductNameEnum.AscendQuest === (productName || featureCode);
};

export const isAscendArchivesProduct = (productName?: string) => {
  const featureCode = getCurrentFeatureCode();
  return ProductNameEnum.AscendArchives === (productName || featureCode);
};

export const isAscendUSAAProduct = (productName?: string) => {
  const featureCode = getCurrentFeatureCode();
  return ProductNameEnum.AscendUSAA === (productName || featureCode);
};
